class HistoryDataCell {
    constructor() {
        this.name = "";
        this.time = 0;
        this.path = "";
        this.localpath = "";
        this.id = "";
    }
}
export default HistoryDataCell